import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import attendance from 'api/attendance';
import { buildRequest } from 'components/Settings/AttendanceAndLeavesSettings/utils';
import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';
import { ATTENDANCE_SETTINGS_QUERY_KEY } from './useAttendanceSettings';
import { parseError } from 'utils/Api';
import { AppError } from 'utils/AppError';

export function useSaveAttendanceSettings() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (formState: Partial<AttendanceSettingsFormState>) =>
      attendance.updateAttendanceSettings(buildRequest(formState)),
    onSuccess: () => {
      queryClient.invalidateQueries([ATTENDANCE_SETTINGS_QUERY_KEY]);
      toast.show({ content: 'Settings saved.', color: 'positive' });
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseError(error),
        color: 'negative',
      });
    },
  });
}
